/**
 * @generated SignedSource<<ceee0a9d96bf4732dfcdf86c548c8fb4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type contentVideoClickToPlayContent$data = {
  readonly entityId: string;
  readonly multimediaEmbed?: {
    readonly json: Schema | null | undefined;
  } | null | undefined;
  readonly urlAlias: string;
  readonly " $fragmentType": "contentVideoClickToPlayContent";
};
export type contentVideoClickToPlayContent$key = {
  readonly " $data"?: contentVideoClickToPlayContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"contentVideoClickToPlayContent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "contentVideoClickToPlayContent",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "urlAlias",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "FormattedValue",
          "kind": "LinkedField",
          "name": "multimediaEmbed",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "json",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Article",
      "abstractKey": null
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};

(node as any).hash = "3afdd76f3f9043a5a00d9d22f493d8db";

export default node;
